import { render } from "./MainTaiChinhToanDien.vue?vue&type=template&id=a82cbb98"
import script from "./MainTaiChinhToanDien.vue?vue&type=script&lang=js"
export * from "./MainTaiChinhToanDien.vue?vue&type=script&lang=js"

import "./MainTaiChinhToanDien.vue?vue&type=style&index=0&id=a82cbb98&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__